module.exports = __webpack_public_path__ + "assets/img/5.256b1a4a.jpg";